import { css } from '@emotion/react'
import { CircleButton, Loading } from '@ruguoapp/jike-fe-components'
import { CloseMiniIcon } from '@ruguoapp/jike-fe-icons'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'
import type { PropsWithChildren } from 'react'

export interface AttachmentProps extends PropsWithChildren<HTMLMotionProps<'div'>> {
	isLoading?: boolean
	onClose?: () => void
}

export default function Attachment({
	isLoading,
	onClose,
	children,

	...props
}: AttachmentProps) {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			css={css`
				position: relative;
			`}
			{...props}
		>
			<div
				css={css`
					position: relative;
				`}
				className="content"
			>
				{children}
				<AnimatePresence>
					{isLoading && (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							css={css`
								position: absolute;
								inset: 0;
								display: flex;
								justify-content: center;
								align-items: center;
								background-color: var(--bg-mask);
								border-radius: 8px;
								pointer-events: none;
							`}
						>
							<Loading
								css={css`
									--dot-color: var(--solid-white-1);
								`}
							/>
						</motion.div>
					)}
				</AnimatePresence>
			</div>
			<CircleButton
				icon={<CloseMiniIcon />}
				appearance="reverse"
				size="sm"
				onClick={(e) => {
					e.stopPropagation()
					onClose?.()
				}}
				css={css`
					cursor: pointer;
					position: absolute;
					top: 0;
					right: 0;
					z-index: 1;
					transform: translate(50%, -50%);
					opacity: 0.8;

					.jk-circle-btn.jk-circle-btn-sm {
						width: 18px;
						height: 18px;

						.jk-circle-btn-icon-wrapper {
							width: 9px;
							height: 9px;
							display: flex;
							justify-content: center;
							align-items: center;
						}
					}
				`}
			/>
		</motion.div>
	)
}
